import {createRef} from 'react';
import {NavigationContainerRef} from '@react-navigation/native';
import {RootStackParamList} from './NavigationConstants';

export const navigationRef =
  createRef<NavigationContainerRef<RootStackParamList>>();

export const navigate = (name: string, params: any) => {
  // @ts-ignore
  navigationRef.current?.navigate(name, params);
};
